import apiClient from "./apiClient";
import { API_ENDPOINTS } from "../config/apiEndpoints";

/**
 * Switch active organisation and return fresh session payload (Modules, Role, etc.).
 */
export async function changeOrganizationSession(
  userData,
  { organizationId, staffId, orgType, mfaVerifiedToken },
) {
  const sessionKey =
    userData?.Sessionkey ||
    userData?.sessionkey ||
    userData?.APIPWD ||
    userData?.apipwd ||
    userData?.SessionKey ||
    "";

  const payload = {
    StaffId: staffId,
    OrganizationId: organizationId,
    EmailId: userData?.EmailId || userData?.emailId || "",
    OrgType: orgType === "CRO" || orgType === "cro" ? "CRO" : orgType || "Site",
    SessionKey: sessionKey,
    IP: "",
    MfaVerifiedToken: mfaVerifiedToken || "",
  };

  return apiClient.post(API_ENDPOINTS.ORGANIZATION.CHANGE_ORGANIZATION, payload);
}
